import React, { useEffect, useState } from 'react'
import LoadSpinner from '../../../components/load-spinner/LoadSpinner';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import CustomTable from '../../../components/custom-table/CustomTable';
import { faMagnifyingGlass, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import useUser from '../../../hooks/useUser';
import SettingCustomTable from '../../../components/custom-table/SettingCustomTable';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { setShowCreateUserModal } from '../../../slice/showModalSlice';
import CreateUser from '../../../components/modals/create-user/CreateUser';
import { setSelectedUser, setShowEditUserModal } from '../../../slice/editUserSlice';
import EditUser from '../../../components/modals/edit-user/EditUser';
import { privileges } from '../../../config/role';
import ApplicationLogsModal from '../../../components/modals/app-log-modal/ApplicationLogsModal';

const DashboardUser = () => {
    // const { getUsers } = useUser()
    const [table,setTable] = useState({});
    const [loadingTable,setLoadingTable] = useState(false);
    const [userList,setUserList] = useState([]);

    const dispatch = useDispatch();

    const userRole = useSelector((state)=> state.user.role);
    const authorized = privileges.editingUsers.includes(userRole);


    const showCreateUserModal = useSelector((state)=> state.showModal.showCreateUserModal);
    const showApplicationLogs = useSelector((state)=> state.showModal.showApplicationLogsModal);

    const {getUsers} = useUser();


    useEffect(()=>{
        getUsersData();
    },[])

    const getUsersData = () => {
      getUsers(
        (data)=>{
          const seen = new Set();
          const unique = data?.content.filter(item => {
            if (seen.has(item.id)) return false;
            seen.add(item.id);
            return true;
          });
          setUserList(unique);
        },
        (error)=>{
          console.log("error",error);
        }
      )

    }


    const headerTable = [
        { label: "Nome", field: "firstname", width: 270 },
        { label: "Cognome", field: "lastname", width: 270 },
        { label: "E-mail", field: "email", width: 270 },
        { label: "Attivo", field: "enabled", width: 270 },
      ];

      const addUser = () =>{
        if(!authorized) return;
        dispatch(setShowCreateUserModal());
      }

    const dataWithClick = (userList || []).map(u => ({
    ...u,
    clickEvent: () => {
      dispatch(setSelectedUser(u));
      dispatch(setShowEditUserModal()); 
    }
  }));


  return (
    <>
      <div className="container-fluid">
        <div className='row px-3'>
          <div className="d-flex align-items-center justify-content-between mb-4 px-1">
            <h1 className="h1 mb-2 text-gray-800 text-primary-custom">Gestione Utenti</h1>
            {authorized && <Button className='btn-custom btn-green' onClick={addUser}>
              <FontAwesomeIcon icon={faUserPlus}/> Aggiungi
            </Button>}
          </div>
        </div>
        <div className="row mb-3">
          {loadingTable
          ?<LoadSpinner/>
          :<SettingCustomTable
            clickIcon={faMagnifyingGlass}
            header={headerTable}
            data={dataWithClick}
            checkable={false}
            label='Utenti'
            />
          }
        </div>
      </div>
      {showCreateUserModal && <CreateUser onSuccess={getUsersData} />}
      <EditUser onSuccess={()=>getUsersData()} />
      {showApplicationLogs && <ApplicationLogsModal />}
      
    </>
  );
}

export default DashboardUser